import { useQuery } from '@tanstack/react-query'

import { responsibleMedicalRecordInstance } from '../..'

export function getListResponsibleMedicalRecordQueryKey(params?: {
  status?: string
  personaName?: string
  month?: number
  year?: number
}) {
  return ['responsibleMedicalRecordList', params].filter(Boolean)
}

export function useListResponsibleMedicalRecordQuery({
  status,
  personaName,
  month,
  year,
  enabled
}: {
  status?: string
  personaName?: string
  month?: number
  year?: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getListResponsibleMedicalRecordQueryKey({
      status,
      personaName,
      month,
      year
    }),
    queryFn: async () =>
      await responsibleMedicalRecordInstance.listResponsibleMedicalRecord({
        status,
        personaName,
        month,
        year
      }),
    enabled
  })
}
